import { render, staticRenderFns } from "./FaixaApp.vue?vue&type=template&id=7a5d81d8&scoped=true&"
import script from "./FaixaApp.vue?vue&type=script&lang=js&"
export * from "./FaixaApp.vue?vue&type=script&lang=js&"
import style0 from "./FaixaApp.vue?vue&type=style&index=0&id=7a5d81d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d81d8",
  null
  
)

export default component.exports